/**
 * Carry a shopper's number to an existing page: `?budget=` in major units,
 * plus `qty=` when it covers several units (a set of 4 tires). The page
 * re-orders its picks for it and says what fits (lib/budget-repick.ts). A
 * budget already in the URL is never overwritten.
 */
export const withBudgetQuery = (
  url: string,
  budget: { max: number; quantity?: number } | null | undefined,
): string => {
  if (!budget?.max || url.includes('budget=')) return url;
  const qty = budget.quantity && budget.quantity > 1 ? `&qty=${Math.floor(budget.quantity)}` : '';
  return `${url}${url.includes('?') ? '&' : '?'}budget=${Math.round(budget.max)}${qty}`;
};
